import { Group, Text } from "@mantine/core";
import { STATUS_LABELS, statusDotColor } from "../../lib/format";

export function StatusBadge({ status }: { status: string }) {
  const label = STATUS_LABELS[status] ?? status.replace(/_/g, " ");
  const color = statusDotColor(status);

  return (
    <Group gap="var(--axio-unit-8)" wrap="nowrap" style={{ display: "inline-flex" }}>
      <span
        aria-hidden
        style={{
          width: "var(--axio-unit-7)",
          height: "var(--axio-unit-7)",
          borderRadius: "var(--axio-radius-circle)",
          backgroundColor: color,
          flexShrink: "var(--axio-number-zero)",
        }}
      />
      <Text size="sm" fw="var(--axio-font-weight-medium)" style={{ color: "var(--mantine-color-text)", textTransform: "capitalize" }}>
        {label}
      </Text>
    </Group>
  );
}
